module.exports = __webpack_public_path__ + "static/TruenoBlk-842cec4d772d3816b5031cd78057ffe8.woff";